<template>
  <div class="modes">
    <BModal :active="isModalOpen" width="28.5em" :can-cancel="false">
      <div class="modes__container">
        <!--    header    -->
        <div class="modes__container__header">
          <div class="modes__container__header__button-container">
            <div
              v-show="arrayActionsHistory.length"
              role="button"
              class="modes__container__header__button-container__button"
              @click="onClickBack"
            >
              <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_back.svg" alt="back" />
            </div>
          </div>
          <div class="modes__container__header__button-container">
            <div role="button" class="modes__container__header__button-container__button" @click="$emit('close')">
              <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_media_close.png" alt="close" />
            </div>
          </div>
        </div>
        <!--    title    -->
        <div class="modes__container__title">
          {{ stringTitle }}
        </div>
        <div class="modes__container__component-container">
          <KeepAlive>
            <Component
              :is="stringSelectedComponent"
              :games-by-match-day="gamesByMatchDay"
              :action-id="objectCurrentAction.actionId"
              :back-counter="numberBackCounter"
              @click-apply-filters="onClickApplyFilters"
              @click-mode="onClickMode"
              @cancel="onClickBack"
              @set-is-loading="onSetIsLoading"
              @click-full-game="onClickFullGame"
            />
          </KeepAlive>
        </div>
      </div>
      <BLoading :active="booleanIsLoading" :is-full-page="false" />
    </BModal>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'MediaPlayerModesModal',
  components: {
    BModal: async () => {
      const { BModal } = await import('buefy/dist/esm/modal');
      return BModal;
    },
    MediaPlayerModesMenu: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerModesMenu'),
    MediaPlayerSearchFilters: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerSearchFilters'),
  },
  props: {
    isModalOpen: {
      type: Boolean,
      default: true,
    },
    gamesByMatchDay: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      numberBackCounter: 0,
      booleanIsLoading: false,
      mapAvailableActions: new Map(),
      stringSelectedComponent: '',
      stringTitle: '',
      arrayActionsHistory: [],
      objectCurrentAction: {},
      objectActionSelected: {},
      arrayAvailableActions: [
        {
          actionId: 0,
          stringComponentName: 'MediaPlayerModesMenu',
          stringTitle: 'Elige lo que deseas ver:',
        },
        {
          actionId: 1,
          stringComponentName: 'MediaPlayerSearchFilters',
          stringTitle: 'Goles de la jornada:',
          stringControlsTitle: 'Goles de jornada',
          numberSelectedType: 1,
        },
        {
          actionId: 2,
          stringComponentName: 'MediaPlayerSearchFilters',
          stringTitle: 'Resumen de un partido:',
          stringControlsTitle: 'Resumen de partido',
          numberSelectedType: 1,
        },
        {
          actionId: 3,
          stringComponentName: 'MediaPlayerSearchFilters',
          stringTitle: 'Resumen de equipo:',
          stringControlsTitle: 'Resumen de equipo',
          numberSelectedType: 3,
        },
        {
          actionId: 4,
          stringComponentName: 'MediaPlayerSearchFilters',
          stringTitle: 'Resumen de jugador:',
          stringControlsTitle: 'Resumen de jugador',
          numberSelectedType: 2,
        },
        {
          actionId: 5,
          stringComponentName: 'MediaPlayerSearchFilters',
          stringTitle: 'Partido completo',
          stringControlsTitle: 'Partido completo',
        },
        {
          actionId: 6,
          stringComponentName: 'MediaPlayerSearchFilters',
          stringTitle: 'Partido completo',
          stringControlsTitle: 'Partido completo',
        },
        {
          actionId: 7,
          stringTitle: 'Sorprendeme',
          stringControlsTitle: 'Sorprendeme',
        },
      ],
    };
  },
  watch: {
    isModalOpen: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.booleanIsLoading = false;
          const objectInitialAction = this.mapAvailableActions.get(0);
          this.arrayActionsHistory = [];
          this.stringTitle = objectInitialAction.stringTitle;
          this.stringSelectedComponent = objectInitialAction.stringComponentName;
          this.objectCurrentAction = objectInitialAction;
        }
      },
    },
  },
  methods: {
    onSetIsLoading(booleanIsLoading) {
      this.booleanIsLoading = booleanIsLoading;
    },
    onClickMode(numberActionId) {
      this.$emit('click-mode', numberActionId);
      this.objectActionSelected = this.mapAvailableActions.get(numberActionId);
      if (numberActionId === 6) {
        this.$emit('click-my-playlists');
        this.$emit('close');
      } else if (numberActionId === 7) {
        this.$emit('click-surprise-me');
        this.$emit('close');
      }
      if (this.objectActionSelected.stringComponentName) {
        this.arrayActionsHistory.push({ ...this.objectCurrentAction });
        this.stringTitle = this.objectActionSelected.stringTitle;
        this.stringSelectedComponent = this.objectActionSelected.stringComponentName;
        this.objectCurrentAction = this.objectActionSelected;
      }
    },
    onClickBack() {
      this.numberBackCounter += 1;
      const objectAction = this.arrayActionsHistory.pop();
      this.stringTitle = objectAction.stringTitle;
      this.stringSelectedComponent = objectAction.stringComponentName;
      this.objectCurrentAction = objectAction;
    },
    onClickApplyFilters(objectDataToFilter) {
      this.$emit('click-apply-filters', {
        ...objectDataToFilter,
        stringControlsTitle: this.objectActionSelected.stringControlsTitle,
        numberSelectedType: this.objectActionSelected.numberSelectedType,
      });
      this.$emit('close');
    },
    onClickFullGame(objectData) {
      this.$emit('click-full-game', {
        ...objectData,
        stringControlsTitle: this.objectActionSelected.stringControlsTitle,
      });
      this.$emit('close');
    },
  },
  created() {
    this.arrayAvailableActions.forEach(objectActionData => {
      this.mapAvailableActions.set(objectActionData.actionId, objectActionData);
    });
  },
};
</script>

<style scoped lang="scss">
.modes {
  font-size: 1rem;
  z-index: 1000;

  &__container {
    width: 100%;
    max-width: 31.25em;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    border-radius: 1em;
    padding-bottom: 2em;

    &__header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px;

      &__button-container {
        &__button {
          padding: 2px 14px;
          border-radius: 25px;
          background-color: #f5f5f5;
          display: flex;
          align-items: center;
          cursor: pointer;

          & > img {
            height: 28px;
            width: 28px;
          }
        }
      }
    }

    &__title {
      font-family: Roboto-Bold, sans-serif;
      font-size: 17px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: -0.17px;
      text-align: center;
      color: #132839;
    }

    &__component-container {
      overflow: hidden;
      display: flex;
      justify-content: center;
      width: 100%;
      margin-top: 1.1em;
    }
  }
}
</style>
